import { GesturesService } from './gestures.service';

export default angular
  .module('sfMobile.services.gestures', [])
  .service('gesturesService', GesturesService).name;
